import { Image, Page, Text, View } from '@react-pdf/renderer';

import logo from '../../../assets/logos/appraisify/appraisify-blue.png';
import { fontStyles, pageStyles, coverPageStyles as styles } from '../styles.ts';
import { CoverPageProps } from '../types.ts';

export const CoverPage = ({
  subjectAddress,
  opinionOfMarketValue,
  totalCostToCure,
  propertyImage,
  intendedUsers,
  effectiveDate,
  shortPropertyType,
  inspectorType,
  appraisalType,
  includeTotalCostToCure,
}: CoverPageProps) => (
  <Page size="A4" style={pageStyles.page}>
    <View style={styles.page}>
      <View>
        <View style={styles.header}>
          <View style={styles.headerRow}>
            <Image src={logo} style={styles.headerLogo} />
            <Text style={styles.headerProductTypeTag}>{appraisalType}</Text>
          </View>
        </View>

        <View style={{ margin: 56 }}>
          <Text style={fontStyles.h1}>Appraisal</Text>
          <Text style={fontStyles.h1}>Report</Text>
        </View>
      </View>

      <View style={{ flexDirection: 'row' }}>
        {propertyImage && <Image src={propertyImage} style={styles.propertyImage} />}

        <View style={styles.details}>
          <View style={styles.detail}>
            <Text style={fontStyles.bodyLight}>Property Location</Text>
            <Text style={fontStyles.h4}>{subjectAddress}</Text>
          </View>
          <View style={styles.detail}>
            <Text style={fontStyles.bodyLight}>Opinion of Market Value</Text>
            <Text style={fontStyles.h4}>{opinionOfMarketValue}</Text>
          </View>
          {includeTotalCostToCure && (
            <View style={styles.detail}>
              <Text style={fontStyles.bodyLight}>Total Cost to Cure</Text>
              <Text style={fontStyles.h4}>{totalCostToCure}</Text>
            </View>
          )}
          {intendedUsers && (
            <View style={styles.detail}>
              <Text style={fontStyles.bodyLight}>Intended User(s)</Text>
              <Text style={fontStyles.h4}>{intendedUsers}</Text>
            </View>
          )}
          <View style={styles.detail}>
            <Text style={fontStyles.bodyLight}>Effective Date</Text>
            <Text style={fontStyles.h4}>{effectiveDate}</Text>
          </View>
        </View>
      </View>

      <View style={styles.tags}>
        {appraisalType.length > 0 && (
          <View style={styles.tag}>
            <Text>Property Type</Text>
            <Text style={styles.tagValue}>{shortPropertyType}</Text>
          </View>
        )}
        {inspectorType.length > 0 && (
          <View style={styles.tag}>
            <Text>Inspector Type</Text>
            <Text style={styles.tagValue}>{inspectorType}</Text>
          </View>
        )}
      </View>
    </View>
  </Page>
);
